import * as ERRORS_LABELS from "../labels/errors";

export const LABELS = {
    [ERRORS_LABELS.ERRORS_TITLE]: "チェックアウトの設定エラー",
    [ERRORS_LABELS.ERRORS_CHECKOUT]: "チェックアウトサービスに接続できません。",
    [ERRORS_LABELS.ERRORS_NO_SCRIPT_ID]: "チェックアウトスクリプトが正しく組み込まれていません。",
    [ERRORS_LABELS.ERRORS_NO_APP_ID]: "アプリケーショントークンが必要です。",
    [ERRORS_LABELS.ERRORS_INVALID_APP_ID]: "アプリケーショントークンが無効です。",
    [ERRORS_LABELS.ERRORS_NO_CHECKOUT]: "’token'または'payment'のチェックアウトタイプが必要です。",
    [ERRORS_LABELS.ERRORS_NOT_PAYMENT_CHECKOUT]: "'payment'のチェックアウトタイプが必要です。",
    [ERRORS_LABELS.ERRORS_SUBSCRIPTION_NOT_ALLOWED_FOR_ONLINE]: "'one_time'のトークンタイプが必要です。",
    [ERRORS_LABELS.ERRORS_INVALID_TOKEN_TYPE]: "トークンタイプには、'one_time'、'subscription'、'recurring'のいずれかを指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_SUBSCRIPTION_RETRY_INTERVAL]: "リトライ間隔が無効です。",
    [ERRORS_LABELS.ERRORS_INVALID_AMOUNT]: "金額は、正の整数で指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_WIDGET_SIZE]: "Widget size must be `sm` (small), `md` (medium), `lg` (large) or `full` (full screen).",
    [ERRORS_LABELS.ERRORS_INVALID_DATE]: "無効な日付フォーマットです。",
    [ERRORS_LABELS.ERRORS_INVALID_CURRENCY]: "お取り扱いできない通貨です。",
    [ERRORS_LABELS.ERRORS_INVALID_SUBSCRIPTION_PERIOD]: "定期課金の期間には、ISO8601のペリオッド、'daily'、'weekly'、'biweekly'、'monthly'、'bimonthly'、'quarterly'、'semiannually'、'annually'のいずれかを指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_LOCALE]: "ロケールは、'auto'またはサポートされているコードのいずれかです。",
    [ERRORS_LABELS.ERRORS_INVALID_USAGE_LIMIT]: "使用制限には、'daily'、'weekly'、'monthly'、'yearly'のいずれかを指定して下さい。",
    [ERRORS_LABELS.ERRORS_UNNECESSARY_AMOUNT]: "商品を設定する場合、金額は省略する必要があります。",
    [ERRORS_LABELS.ERRORS_UNNECESSARY_CURRENCY]: "商品を設定する場合、通貨は省略する必要があります。",
    [ERRORS_LABELS.ERRORS_UNNECESSARY_SUBSCRIPTION_ID]: "定期課金IDを指定する場合には、トークンタイプは、'subscription'を指定して下さい。",
    [ERRORS_LABELS.ERRORS_UNNECESSARY_INSTALLMENT_PLAN]: "分割払いプランを指定する場合には、トークンタイプは、'subscription'を指定して下さい。",
    [ERRORS_LABELS.ERRORS_UNNECESSARY_INSTALLMENT_PLAN_QTY]: "分割払いパラメータを指定する場合には、トークンタイプは、'subscription'を指定して下さい。",
    [ERRORS_LABELS.ERRORS_NO_SUBSCRIPTION_PERIOD]: "定期課金の期間を指定して下さい。",
    [ERRORS_LABELS.ERRORS_TITLE_TOO_LONG]: "｀Titleは、最大64文字です。",
    [ERRORS_LABELS.ERRORS_INVALID_INSTALLMENT_PLAN]: "分割払いプランには、'revolving'、'fixed_cycles'のいずれかを指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_SUBSCRIPTION_PLAN]: "分割払いプランには、'fixed_cycles'、'fixed_cycle_amount'のいずれかを指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_INSTALLMENT_AMOUNT]: "金額は、正の整数で指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_INSTALLMENT_INITIAL_AMOUNT]: "金額は、正の整数で指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_CUSTOMER_ID]: "カスタマーIDは、UUID形式で指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_TIMEZONE]: "無効なタイムゾーンです。",
    [ERRORS_LABELS.ERRORS_INVALID_PAYMENT_TYPE]: "サポートされていない支払い方法です。",
    [ERRORS_LABELS.ERRORS_INVALID_PAYMENT_TYPES]: "サポートされていない支払い方法です。",
    [ERRORS_LABELS.ERRORS_INVALID_INSTALLMENTS]: "サポートされていない分割払いサイクルです。1、3、5、6、10、12、15、18、20、24かrevolvingを指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_PRODUCTS]: "商品は”,”で区切られたUUID形式のリストで指定してください。",
    [ERRORS_LABELS.ERRORS_INVALID_AUTH_CODE]: "認証コードが正しくありません。",
    [ERRORS_LABELS.ERRORS_INVALID_COLOR_CODE]: "カラーコードは#で始まる3桁または6桁の16進数で指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_LOGO_TYPE]: "ロゴタイプには'Background'、'Centered'、'None'のいずれかを指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_SHIPPING_ADDRESS]: "The shipping address is invalid",
    [ERRORS_LABELS.ERRORS_INVALID_SHIPPING_ADDRESS_COUNTRY_CODE]: "The address's country code is invalid",
    [ERRORS_LABELS.ERRORS_INVALID_SHIPPING_ADDRESS_ZIP]: "The address's zip code is invalid",
    [ERRORS_LABELS.ERRORS_EXPIRATION_TIMESHIFT]: "振込期限の時刻が正しくありません。",
    [ERRORS_LABELS.ERRORS_EXPIRATION_PERIOD]: "有効期限が無効です。",
    [ERRORS_LABELS.ERRORS_PAIDY_ZIP_CODE_REQUIRED]: "Zip code value is required for Paidy payment type",
    [ERRORS_LABELS.ERRORS_INVALID_METADATA]: "Metadata should be a record of string, number or boolean.",
    [ERRORS_LABELS.ERRORS_GENERIC]: "不正なパラメータが指定されています。",
    [ERRORS_LABELS.ERRORS_INVALID_ALLOW_INSTALLMENTS_CHECKOUT]: "'allowCardInstallments'パラメータを指定する場合には、'checkout'は、'token'、'payment'のいずれかを指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_ALLOW_INSTALLMENTS_TOKEN_TYPE]: "'allowCardInstallments'パラメータを指定する場合には、トークンタイプは、'one_time'、'recurring'のいずれかを指定して下さい。",
    [ERRORS_LABELS.ERRORS_INVALID_ALLOW_INSTALLMENTS_USAGE_LIMIT]: "'allowCardInstallments'パラメータを指定する場合には、パラメーターから使用制限を消して下さい。",
    [ERRORS_LABELS.ERRORS_NO_CUSTOM_FIELD_KEY]: "カスタムフィールドのキーが必要です。",
    [ERRORS_LABELS.ERRORS_NO_CUSTOM_FIELD_LABEL]: "カスタムフィールドのラベルが必要です。",
    [ERRORS_LABELS.ERRORS_NO_CUSTOM_FIELD_TYPE]: "カスタムフィールドのタイプは'select'または'string'である必要があります。",
    [ERRORS_LABELS.ERRORS_NO_CUSTOM_FIELD_OPTIONS]: "'select'タイプのカスタムフィールドには選択肢のリストが必要です。",
    [ERRORS_LABELS.ERRORS_INVALID_THREE_DS_MODE]: "3DSモードには、'normal'、'require'、'force'のいずれかを指定して下さい。",
    [ERRORS_LABELS.PAYMENT_TYPE_NOT_SUPPORTED]: "指定された支払い区分（分割回数など）が非対応のカードです。",
    [ERRORS_LABELS.THREE_DS_COULD_NOT_BE_COMPLETED]: "3Dセキュア認証が完了できませんでした",
    [ERRORS_LABELS.CARD_NOT_ENROLLED_IN_THREE_DS]: "カード会員がサービスに登録されていません",
    [ERRORS_LABELS.IDENTITY_VERIFICATION_INCOMPLETE]: "プロセス失敗",
    [ERRORS_LABELS.INSTALLMENT_CYCLES_NOT_AVAILABLE_FOR_METHOD]: "選択された分割払いサイクルは、この支払い方法ではご利用いただけません",
    [ERRORS_LABELS.UNFINISHED_CHARGE_EXIST_FOR_TOKEN]: "トークンの未完了の請求があります。",
    [ERRORS_LABELS.PAYMENT_EXPIRATION_EXCEEDS_PERIOD]: "入金期限は次回課金日より前に指定してください。",

    [ERRORS_LABELS.DISPUTED_TRANSACTION]: "無効な取引",
    [ERRORS_LABELS.MISSING_THREE_DS_SERVER_TRANS_ID]: "盗難カード",
    [ERRORS_LABELS.UNKNOWN_DEVICE]: "不明なデバイス",
    [ERRORS_LABELS.UNSUPPORTED_DEVICE]: "サポートされていないデバイス",
    [ERRORS_LABELS.SECURITY_BREACH]: "セキュリティ障害",
    [ERRORS_LABELS.LOW_CONFIDENCE]: "信頼度が低い",
    [ERRORS_LABELS.MEDIUM_CONFIDENCE]: "信頼度が中程度",
    [ERRORS_LABELS.HIGH_CONFIDENCE]: "信頼度が高い",
    [ERRORS_LABELS.VERY_HIGH_CONFIDENCE]: "信頼度が非常に高い",
    [ERRORS_LABELS.EXCEEDED_MAX_CHALLENGE_AT_ACS]: "ACSの最大チャレンジを超える",
    [ERRORS_LABELS.NON_PAYMENT_TRANSACTIONS_NOT_SUPPORTED]: "非決済取引はサポートされていません",
    [ERRORS_LABELS.THREE_RI_TRANSACTIONS_NOT_SUPPORTED]: "3RIトランザクションはサポートされていません",
    [ERRORS_LABELS.TECHNICAL_ISSUES_AT_ACS]: "ACSの技術的な問題",
    [ERRORS_LABELS.EXCEEDED3DS_REQUESTOR_DECOUPLED_MAX_TIME]: "3DS Requestor Decoupled Max Timeを超えました",
    [ERRORS_LABELS.DECOUPLED_AUTH_NOT_REQUESTED]: "ACSによってDecoupled認証が必要と判断されたが、3DSリクエスターからは要求されていません",
    [ERRORS_LABELS.INSUFFICIENT_TIME_FOR_DECOUPLED_AUTH]: "Decoupled認証のための、カード会員を認証するのに十分な時間が与えられませんでした。",
    [ERRORS_LABELS.AUTH_ATTEMPTED_BUT_NOT_EXECUTED_BY_CARDHOLDER]: "認証は試行されましたが、カード会員によって実行されませんでした",

    [ERRORS_LABELS.GENERIC_THREE_DS_PROCESSING_ERROR]: "3Dセキュア認証が失敗しました。詳細はカード会社へお問い合わせください。",
    [ERRORS_LABELS.PROCESSING_ERROR]: "処理エラー",
};

export default LABELS;
